<div class="return-expiry-threshold page-container" *ngIf="canView()">
  <p-toast />
  <div class="page-header">
    <h2>{{ 'return_expiry_threshold.title' | translate }}</h2>
    <p class="subtitle">
      {{ 'return_expiry_threshold.subtitle' | translate }}
    </p>
  </div>

  <div class="form-card" [class.loading]="loading()">
    <div class="field">
      <label for="minRemainingDays">
        {{ 'return_expiry_threshold.fields.min_remaining_days' | translate }}
      </label>
      <p-inputNumber
        inputId="minRemainingDays"
        [ngModel]="minRemainingDays()"
        (ngModelChange)="minRemainingDays.set($event)"
        [min]="0"
        [disabled]="!canEdit() || loading() || saving()"
        [showButtons]="true"
      />
    </div>

    <div class="field row">
      <label for="enabled">
        {{ 'return_expiry_threshold.fields.enabled' | translate }}
      </label>
      <p-toggleswitch
        inputId="enabled"
        [ngModel]="enabled()"
        (ngModelChange)="enabled.set($event)"
        [disabled]="!canEdit() || loading() || saving()"
      />
    </div>

    <div class="actions" *ngIf="canEdit()">
      <app-button
        [label]="'common.actions.save' | translate"
        severity="info"
        [loading]="saving()"
        [disabled]="loading()"
        (emitOnClick)="save()"
      />
    </div>
  </div>
</div>
